<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("placement") }}</h3>
    <div>
      <div class="admin_container">
        <div class="scan-qr_btn mb-3 d-flex justify-space-between align-center">
          <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
            <form
              @submit.prevent="handleSubmit(sendQrCode)"
              class="d-flex align-center"
            >
              <div class="py-2">
                <CustomInputText
                  name="id"
                  placeholder="ID"
                  :rules="{
                    required: true,
                  }"
                  v-model="productItemId"
                  class="user_input no-margin pr-3"
                ></CustomInputText>
              </div>
              <VBtn type="submit" color="primary">{{ $t("addQrCode") }}</VBtn>
            </form>
          </ValidationObserver>
          <div class="d-flex align-center">
            <div class="py-2">
              <VueSelect
                clearable
                infinite
                rules="required"
                @item-resolved="setWarehouses"
                @next-page-resolved="
                  (data) => setWarehouses([...warehouses, ...data])
                "
                :get-item-promise="
                  ({ text, page }) =>
                    getWarehouse({ name: text, page, limit: 15 })
                "
                :items="warehouses"
                v-model="warehouseId"
                item-text="name"
                :placeholder="$t('warehouse')"
                class="pr-3"
              ></VueSelect>
            </div>
            <VBtn
              type="submit"
              @click="openPlacementDialog()"
              color="success"
              :disabled="disabled"
              >{{ $t("determinePlacement") }}</VBtn
            >
          </div>
        </div>

        <div class="division_main">
          <div class="mobile_simple overflow-auto">
            <TableWithFilter :headers="headers" :items="items" fixed-header>
            </TableWithFilter>
          </div>
        </div>
      </div>
    </div>
    <DeterminePlacement
      ref="determinePlacementDialogRef"
      :productItems="items"
      :productItemIds="productItemIds"
      @clearProductItemIds="clearProductItemIds()"
    ></DeterminePlacement>
  </div>
</template>

<script>
import DeterminePlacement from "@/components/omtk/DeterminePlacement.vue";
import TableWithFilter from "@/components/ui/table/TableWithFilter.vue";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import { fullTrim, makerPagination } from "@/utils/pureFunctions.js";
export default {
  data() {
    return {
      productItemId: null,
      productItemIds: [],
      items: [],
      warehouses: [],
      warehouseId: null,
    };
  },
  components: {
    DeterminePlacement,
    TableWithFilter,
    VueSelect,
  },

  methods: {
    async sendQrCode() {
      if (
        this.productItemIds.length > 0 &&
        this.productItemIds.includes(this.productItemId)
      ) {
        const {
          /**
           * @type {Object}
           * @property {function} setErrors
           */
          formObs,
        } = this.$refs;
        formObs.setErrors({ id: this.$t("existingQr") });
        return;
      }
      this.showLoading();
      try {
        await this.$http.get(
          `product-item/qr-code/mobile/${fullTrim(this.productItemId)}`
        );
        this.productItemIds.push(this.productItemId);
        await this.getProductDetails();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getProductDetails() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get(
          `product-item/qr-code/detail-list?${this.productItemIds
            .map((id) => `productItemIds=${id}`)
            .join("&")}`
        );
        this.items = data;
        this.productItemId = null;
        this.$refs.formObs.reset();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    openPlacementDialog() {
      const { determinePlacementDialogRef } = this.$refs;
      if (determinePlacementDialogRef) {
        determinePlacementDialogRef.open(this.warehouseId);
      }
    },
    setWarehouses(warehouses) {
      this.warehouses = warehouses;
    },
    async getWarehouse(params) {
      this.showLoading();
      try {
        const {
          data: { data, total },
        } = await this.$http.get("warehouse/own-list", {
          params,
        });
        return {
          data,
          lastPage: makerPagination({ limit: params.limit, total }).lastPage,
        };
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    clearProductItemIds() {
      this.productItemIds = [];
      this.items = [];
      this.warehouseId = null;
      this.$refs.determinePlacementDialogRef.close();
    },
  },
  computed: {
    headers() {
      return [
        {
          value: "numb",
          text: this.$t("nContract"),
        },
        {
          value: "count",
          text: this.$t("count"),
        },
        {
          value: "id",
          text: this.$t("qrCode"),
        },
        {
          value: "productTypeName",
          text: this.$t("typeProduct"),
        },
        {
          value: "productGroupName",
          text: this.$t("productGroup"),
        },
        {
          value: "productName",
          text: this.$t("productName"),
        },
      ];
    },
    disabled() {
      return this.items.length == 0 || this.warehouseId == null;
    },
  },
};
</script>
